export default __webpack_public_path__ + "static/media/MOSIP_Site_Logo.5860894c.png";